import { render, staticRenderFns } from "./RealEstateChallenges.vue?vue&type=template&id=84780d32&scoped=true&"
import script from "./RealEstateChallenges.vue?vue&type=script&lang=js&"
export * from "./RealEstateChallenges.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateChallenges.vue?vue&type=style&index=0&id=84780d32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84780d32",
  null
  
)

export default component.exports